export default {
  label: 'Access code',
  buttonLabel: 'Sign in',
  errorMessage: 'Invalid access code',
};
